export const menuData = [
  { title: "Home", link: "/" },
  { title: "About Us", link: "/about-us" },
  { title: "Current Opportunities", link: "/current-opportunities" },
];
